import { toastError, toastSuccess } from 'bench-internal-theme';

export interface NotificationService {
  showSuccess: (title: string, message: string) => void;
  showError: (title: string, message: string) => void;
  showWarning: (title: string, message: string) => void;
}

export class DefaultNotificationService implements NotificationService {
  showSuccess(title: string, message: string): void {
    toastSuccess(title, message, { position: 'top-right' });
  }

  showError(title: string, message: string): void {
    toastError(title, message, { position: 'top-right' });
  }

  showWarning(title: string, message: string): void {
    // Use error toast with warning-style title since bench-internal-theme doesn't have toastWarning
    toastError(`⚠️ ${title}`, message, { position: 'top-right' });
  }
}
export class MockNotificationService implements NotificationService {
  public notifications: Array<{
    type: 'success' | 'error' | 'warning';
    title: string;
    message: string;
  }> = [];

  showSuccess(title: string, message: string): void {
    this.notifications.push({ type: 'success', title, message });
  }

  showError(title: string, message: string): void {
    this.notifications.push({ type: 'error', title, message });
  }

  showWarning(title: string, message: string): void {
    this.notifications.push({ type: 'warning', title, message });
  }

  clear(): void {
    this.notifications = [];
  }

  getLastNotification() {
    return this.notifications[this.notifications.length - 1];
  }
}

export const notificationService = new DefaultNotificationService();
